import { apiClient, type components } from '@boothiva/api-client';

export type Session = components['schemas']['SessionResponse'];

export const enterSupportSession = (ticket: string) =>
  apiClient.post<Session>('/api/v1/support/enter', { ticket });
export const endSupportSession = () => apiClient.post<void>('/api/v1/support/end-session');
